import React from 'react';
import { Grid } from '@material-ui/core';
import {
  TextFormattedNumber,
} from 'components';
import QuoteListingsSummaryItem from './QuoteListingsSummaryItem';


const QuoteListingsSummary = ({
  discount,
  subTotal,
  total,
}) => (
  <Grid item xs={12} lg={3}>
    <QuoteListingsSummaryItem label="Subtotal:" value={subTotal} prefix="$" />
    <QuoteListingsSummaryItem label="Discount:" value={discount} prefix="$" />
    <div className="flex items-center justify-between mb-2">
      <div className="font-semibold">TOTAL</div>
      <div className="text-right">
        <TextFormattedNumber value={total} prefix="$" />
      </div>
    </div>
  </Grid>
);

export default QuoteListingsSummary;
